var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SuiModal',{staticClass:"chat-modal",attrs:{"basic":"","close-icon":"","open":_vm.open},on:{"changed":function($event){return _vm.$emit('changed', false)}}},[(_vm.opened)?_c('iframe',{ref:"iframe",attrs:{"src":_vm.iframeSrc}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }